module.exports = __webpack_public_path__ + "img/01.cc19af01.png";